import { Stack, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { UI_SIZES } from 'app-constants'
import { ReactComponent as JelledLogo } from 'components/NavBar/jelled-final-logo.svg'
import SadFace from './graphic/SadFace.png'
import SadFace2x from './graphic/SadFace@2x.png'
import SadFace3x from './graphic/SadFace@3x.png'
import { authenticatedUserAtom } from 'state'
import { useRecoilValue } from 'recoil'

const TwinNotFoundContainer = styled.div`
  height: calc(100vh - ${UI_SIZES.TOP_PADDING}px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export default function TwinNotFound() {
  const user = useRecoilValue(authenticatedUserAtom)
  const shouldShowJelledLogo = !user

  return (
    <TwinNotFoundContainer>
      <Stack justifyContent="flex-end" alignItems="center" spacing={4}>
        {shouldShowJelledLogo && (
          <JelledLogo
            style={{
              width: '126px',
              height: '30px',
            }}
          />
        )}
        <img src={SadFace} srcSet={`${SadFace}, ${SadFace2x} 2x, ${SadFace3x} 3x`} alt="" />
        <Stack justifyContent="flex-end" alignItems="center" spacing={1} mb={6}>
          <Typography variant="h3.5">Oops! You can't access this twin.</Typography>
          <Typography variant="pS" color="#666666">
            The twin’s creator has not made their twin accessible to users outside their organization.
          </Typography>
        </Stack>
      </Stack>
    </TwinNotFoundContainer>
  )
}
